<template>
    <div id="app" class="container">
        <weui-dialog :visible="alertShow" :title="alertTitle" :message="alertMessage" :buttons="alertButtons" @click="alertCancel" />
        <router-view class="main"></router-view>
        <weui-footer class="footer"></weui-footer>
        <weui-load-more :show="loading" />
    </div>
</template>

<script>
import WeuiDialog from "@/components/weui/Dialog"
import WeuiLoadMore from "@/components/weui/LoadMore"
import WeuiFooter from "@/components/weui/Footer"

export default {
    name: "App",
    computed: {
        alertShow: function() {
            return this.$store.state.alert.show;
        },
        alertTitle: function () {
            return this.$store.state.alert.title;
        },
        alertMessage: function () {
            return this.$store.state.alert.message;
        },
        alertButtons: function () {
            return this.$store.state.alert.buttons;
        },
        loading: function() {
            return this.$store.state.loading;
        }
    },
    methods: {
        alertCancel() {
            this.$store.commit('alert/hide');
        }
    },
    components: { 
        WeuiDialog,
        WeuiLoadMore,
        WeuiFooter
    }
};
</script>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .main{
        /* background: orange; */
        flex: 1 0 auto;
    }
    .footer{
        /* background: #333; */
        flex: 0 0 auto;
    }
</style>
